import React from 'react'
import type { SxProps, Theme } from '@mui/material'

import { Translation } from '../../../domain'

import { DocumentationType } from '../../../application'

import { DocumentationLink } from '../Documentation'
import { ErrorMessage } from '../ErrorMessage'
import { FormattedTranslation } from '../Internationalization'
import type { RouterProps } from '../routing'

const linkStyle: SxProps<Theme> = { ml: 1 }

export const DeniedAccess: RouterProps['deniedAccess'] = ({ error }) => (
    <ErrorMessage
        error={error}
        customTitle={(e) => e.message}
        extrasTitleSuffix={
            <DocumentationLink type={DocumentationType.UI_ACCESS_PERMISSIONS} sx={linkStyle} data-testid="ui-access-documentation" variant="body2">
                <FormattedTranslation id={Translation.ABOUT_UI_ACCESS_PERMISSIONS} />
            </DocumentationLink>
        }
        extras="section"
    />
)
